export const blogs = [
  {
    id: 1,
    title: "What to See in Paracas in Just One Day (Without Missing Anything)",
    title_es: "Qué Ver en Paracas en Un Solo Día (Sin Perderte Nada)",
    summary: "Discover the must-see places of Paracas in 24 hours: Ballestas Islands, National Reserve, Huacachina, vineyards, and more.",
    summary_es: "Descubre los lugares imprescindibles de Paracas en 24 horas: Islas Ballestas, Reserva Nacional, Huacachina, viñedos y más.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Guide, Tours, Paracas",
    category_es: "Guía, Tours, Paracas",
    image: "/tour-images/Paracas/paracas-full-day.jpg",
    slug: "what-to-see-in-paracas-in-one-day"
  },

  {
    id: 2,
    title: "Desert Adventure: Sandboarding and Buggying in Paracas",
    title_es: "Aventura en el Desierto: Sandboarding y Buggies en Paracas",
    summary: "Experience the adrenaline rush of sandboarding and buggy riding along the Dakar route over the Paracas dunes.",
    summary_es: "Vive la adrenalina del sandboarding y los paseos en buggy por la ruta Dakar en las dunas de Paracas.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Adventure, Nature, Paracas",
    category_es: "Aventura, Naturaleza, Paracas",
    image: "/tour-images/Paracas/sandboard-dakar.jpg",
    slug: "sandboarding-and-buggy-in-paracas",
  },

  {
    id: 3,
    title: "Paracas National Reserve: Complete Guide for Your Visit",
    title_es: "Reserva Nacional de Paracas: Guía Completa para tu Visita",
    summary: "Explore red beaches, geological viewpoints, and discover the marine biodiversity of the Paracas National Reserve.",
    summary_es: "Explora playas rojas, miradores geológicos y descubre la biodiversidad marina de la Reserva Nacional de Paracas.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Nature, Reserve, Paracas",
    category_es: "Naturaleza, Reserva, Paracas",
    image: "/tour-images/Paracas/reserva-paracas.jpg",
    slug: "paracas-national-reserve",
  },

  {
    id: 4,
    title: "Everything you need to know before visiting the Ballestas Islands",
    title_es: "Todo lo que Necesitas Saber Antes de Visitar las Islas Ballestas",
    summary: "Tips, schedules, and what you can see: penguins, sea lions, seabirds, and the famous Candelabro geoglyph.",
    summary_es: "Consejos, horarios y qué podrás ver: pingüinos, lobos marinos, aves marinas y el famoso geoglifo del Candelabro.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Nature, Marine life, Paracas",
    category_es: "Naturaleza, Vida Marina, Paracas",
    image: "/tour-images/Paracas/islas-ballestas.jpg",
    slug: "ballestas-islands-paracas",
  },

  {
    id: 5,
    title: "Private tour in Paracas: exclusivity tailored to you",
    title_es: "Tour Privado en Paracas: Exclusividad Hecha a tu Medida",
    summary: "Enjoy a completely personalized private tour to explore Paracas with your family or private groups.",
    summary_es: "Disfruta de un tour privado totalmente personalizado para explorar Paracas con tu familia o grupo privado.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "VIP, Private, Paracas",
    category_es: "VIP, Privado, Paracas",
    image: "/tour-images/Paracas/private-tour.jpg",
    slug: "private-tour-in-paracas",
  },

  {
    id: 6,
    title: "Yacht Charter in Paracas: Luxury and freedom at sea",
    title_es: "Alquiler de Yates en Paracas: Lujo y Libertad en el Mar",
    summary: "Sail on your own yacht with a customized itinerary, ideal for groups, events, or photography in Paracas.",
    summary_es: "Navega en tu propio yate con un itinerario personalizado, ideal para grupos, eventos o sesiones de fotos en Paracas.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Luxury, Sea, Paracas",
    category_es: "Lujo, Mar, Paracas",
    image: "/tour-images/Paracas/yacht-charter.jpg",
    slug: "yacht-charter-in-paracas",
  },

  {
    id: 7,
    title: "Special Services in Paracas: Scientific Expeditions and Filming",
    title_es: "Servicios Especiales en Paracas: Expediciones Científicas y Filmaciones",
    summary: "Specialized logistical assistance for research, filming, or environmental work in Paracas.",
    summary_es: "Asistencia logística especializada para investigación, filmaciones o trabajo ambiental en Paracas.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Science, Filming, Paracas",
    category_es: "Ciencia, Filmación, Paracas",
    image: "/tour-images/Paracas/special-services.jpg",
    slug: "special-services-in-paracas",
  },

  {
    id: 8,
    title: "Flying over the Nazca Lines from Paracas: Is it worth it?",
    title_es: "Sobrevolar las Líneas de Nazca desde Paracas: ¿Vale la Pena?",
    summary: "Experience the thrill of flying over the enigmatic Nazca Lines, departing comfortably from Paracas.",
    summary_es: "Vive la emoción de sobrevolar las enigmáticas Líneas de Nazca, partiendo cómodamente desde Paracas.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "History, Nazca, Culture",
    category_es: "Historia, Nazca, Cultura",
    image: "/tour-images/Paracas/nazca-flight.jpg",
    slug: "nazca-lines-from-paracas",
  },

  {
    id: 9,
    title: "Paracas Marine Fauna: Humboldt Penguins, Sea Lions, and More",
    title_es: "Fauna Marina de Paracas: Pingüinos de Humboldt, Lobos Marinos y Más",
    summary: "Admire the incredible marine life of Paracas on a unique tour of the Peruvian Pacific.",
    summary_es: "Admira la increíble vida marina de Paracas en un tour único por el Pacífico peruano.",
    date: "June 20, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Marine Life, Fauna, Paracas",
    category_es: "Vida Marina, Fauna, Paracas",
    image: "/tour-images/Paracas/fauna-marina.jpg",
    slug: "marine-fauna-in-paracas",
  },
  {
    id: 10,
    title: "Flying Over the Nazca Lines from Pisco: Save Time and Enjoy More",
    title_es: "Sobrevolar las Líneas de Nazca desde Pisco: Ahorra Tiempo y Disfruta Más",
    summary: "Discover a faster way to explore the mysterious Nazca Lines by flying directly from Pisco, avoiding long road trips from Lima or Nazca.",
    summary_es: "Descubre una forma más rápida de explorar las misteriosas Líneas de Nazca volando directamente desde Pisco, evitando largos viajes por carretera desde Lima o Nazca.",
    date: "June 26, 2025",
    author: "Team TurismoNauticoParacas",
    category: "Nazca, Flights, Culture",
    category_es: "Nazca, Vuelos, Cultura",
    image: "/tour-images/Paracas/nazca-lines-pisco.jpg",
    slug: "nazca-lines-from-pisco"
  },
  {
    id: 11,
    title: "The Enigma of Mount Sierpe",
    title_es: "El Enigma del Cerro Sierpe",
    date: "2014-04-20",
    author: "Rein Petersen",
    category: "History and Culture",
    category_es: "Historia y Cultura",
    summary: "Discover the mysteries of Mount Sierpe and its geoglyph known as the 'Avenue of Holes.' A pre-Incan legacy linked to rain rituals, ancestral deities, and possible messages to the gods.",
    summary_es: "Descubre los misterios del Cerro Sierpe y su geoglifo conocido como la 'Avenida de los Hoyos'. Un legado preincaico ligado a rituales de lluvia, deidades ancestrales y posibles mensajes a los dioses.",
    image: "/tour-images/Paracas/montesierpe.jpg",
    slug: "montesierpe"
  },
  {
    id: 12,
    title: "Guano Collectors",
    title_es: "Recolectores de Guano",
    date: "2014-02-22",
    author: "Rein Petersen",
    category: "History and Culture",
    category_es: "Historia y Cultura",
    summary: "The worst enemy is not the smell, heat or exhaustion. As Domingo León explained to us, the worst enemy is dust sticking on the eyebrows, covering our noses and cheeks and turning our face into a rigid mask.",
    summary_es: "El peor enemigo no es el olor, el calor ni el cansancio. Como nos explicó Domingo León, el peor enemigo es el polvo que se pega en las cejas, cubre la nariz y las mejillas, convirtiendo el rostro en una máscara rígida.",
    image: "/tour-images/Paracas/guano_collectors.jpg",
    slug: "guano-collectors"
  }


];

export const getBlogText = (blog, lang) =>
  lang === "es"
    ? {
        title: blog.title_es || blog.title,
        summary: blog.summary_es || blog.summary,
        category: blog.category_es || blog.category,
      }
    : { title: blog.title, summary: blog.summary, category: blog.category };
